import { render } from "./App.vue?vue&type=template&id=face4fb6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=face4fb6&lang=less"

import exportComponent from "E:\\Zdong\\code\\2026-8-19_尧彩新\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__